module.exports = __webpack_public_path__ + "img/remove-true-block.3bc2c343.png";